import { NgClass, ViewportScroller } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, inject, input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ish-paging',
  templateUrl: './paging.component.html',
  styleUrls: ['./paging.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent, NgClass, TranslateModule],
})
export class PagingComponent implements OnChanges {
  private scroller = inject(ViewportScroller);

  readonly currentPage = input.required<number>();
  readonly lastPage = input.required<number>();

  readonly goToPage = output<number>();

  pageIndices: number[] = [];

  ngOnChanges(): void {
    const currentPage = this.currentPage();
    const lastPage = this.lastPage();
    if (currentPage && lastPage) {
      this.pageIndices = this.getPages(currentPage, lastPage);
    }
  }
  /**
   * If the user changes the page the goToPage event is emitted
   *
   * @param page : changed page number
   */
  setPage(page: number) {
    this.goToPage.emit(page);
    this.scroller.scrollToPosition([0, 0]);
  }

  /**
   * Determines the page array - elements with the value of -1 will be shown as ...
   *
   * @param current current page
   * @param total   number of pages
   * @returns       pages array
   */
  private getPages(current: number, total: number): number[] {
    if (total <= 8) {
      return [...Array(total).keys()].map(x => x + 1);
    }

    if (current > 4) {
      if (current >= total - 3) {
        return [1, -1, total - 5, total - 4, total - 3, total - 2, total - 1, total];
      } else {
        return [1, -1, current - 2, current - 1, current, current + 1, current + 2, -1, total];
      }
    }

    return [1, 2, 3, 4, 5, 6, -1, total];
  }
}
